import {FaBars, FaHome, FaSignOutAlt, FaWpforms} from "react-icons/fa";
import React from "react";
import { Link } from "react-router-dom";

export function HeaderDashboard({toggleSidebar}) {
    return (
        <header className=" sticky-top bg-primary text-white p-3 d-flex justify-content-between align-items-center w-100 shadow-sm">
            <button className="btn btn-light " onClick={toggleSidebar}>
                <FaBars />
            </button>
            <h4 className="m-0">Dashboard</h4>
        </header>
    );
}
export function SideNav({isOpen}) {

    function LogOut() {
        sessionStorage.removeItem('data');
        window.location.reload();
    }

    return (
        <div className={`bg-dark text-white sidebar ${isOpen ? "open" : "closed"} p-4 shadow-lg `}>
            <h3 className="text-center mb-4">Admin Panel</h3>
            <ul className="nav flex-column">
                <li className="nav-item mb-3">
                    <Link to={"/admin/home"}  className="nav-link text-white">
                        <FaHome className="me-2" /> Home
                    </Link>
                </li>
                <li className="nav-item mb-3">
                    <Link to={"/admin/form8Page"} className="nav-link text-white">
                        <FaWpforms className="me-2" /> Form 8
                    </Link>
                </li>
                <li className="nav-item mb-3">
                    <Link to={"/admin/form9Page"} className="nav-link text-white">
                        <FaWpforms className="me-2" /> Form 9
                    </Link>
                </li>
                <li className="nav-item mb-3">
                    <Link to={"/admin/form10Page"} className="nav-link text-white">
                        <FaWpforms className="me-2" /> Form 10
                    </Link>
                </li>
                <li className="nav-item mt-5">
                    <a href="#" onClick={LogOut} className="nav-link text-white">
                        <FaSignOutAlt className="me-2" /> Logout
                    </a>
                </li>
            </ul>
        </div>
    );
}